import { format } from 'date-fns';

/** Wall-clock datetime for Google Calendar API when paired with `timeZone`. */
export function toGoogleCalendarDateTime(date: Date): string {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss");
}

/** Parse yyyy-MM-dd + HH:mm in the local timezone (avoids UTC date-only parsing). */
export function parseLocalDateAndTime(dateStr: string, timeStr: string): Date {
  const [y, mo, d] = dateStr.split('-').map(Number);
  const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
  return new Date(y, mo - 1, d, hh, mm, 0, 0);
}
